<template>
  <div class="modal" select-cy="confirm">
    <div :class="'card confirm ' + color">
      <!-- Content -->
      <div class="content">
        <div class="icon">!</div>
        <div class="headline">{{ headline }}</div>
        <div class="details">{{ details }}</div>
      </div>

      <!-- Commands -->
      <div class="commands">
        <button class="secondary" type="button" @click="confirm(false)" select-cy="confirm-cancel">Cancel</button>
        <button class="primary" type="button" @click="confirm(true)" select-cy="confirm-accept">{{ action }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Confirm',

  computed: {
    ...mapState({
      headline: (state) => state.confirm.headline,
      details: (state) => state.confirm.details,
      color: (state) => state.confirm.color,
      action: (state) => state.confirm.action,
    }),
  },
  methods: {
    confirm(payload) {
      this.$store.commit('confirm/resolve', payload);
    },
  },
};
</script>

<style scoped>
.modal {
  @apply z-50;
}

.confirm {
  @apply flex flex-col items-center justify-center p-4 max-w-sm;

  &.danger {
    .content {
      .icon {
        @apply text-red-500 border-2 border-red-500 shadow-sm;
      }
    }

    .commands {
      .primary {
        @apply bg-red-500 border-red-500;
      }

      .secondary {
        @apply text-red-500 border-red-500;
      }
    }
  }

  &.info {
    .content {
      .icon {
        @apply text-blue-400 border-2 border-blue-400 shadow-sm;
      }
    }

    .commands {
      .primary {
        @apply bg-blue-400 border-blue-400;
      }

      .secondary {
        @apply text-blue-400 border-blue-400;
      }
    }
  }
}

.content {
  @apply flex flex-col p-4 text-center overflow-y-auto;

  .icon {
    @apply flex items-center justify-center w-10 h-10 mx-auto my-0 mb-4 font-secondary font-semibold
    text-2xl rounded-full;
  }

  .headline {
    @apply mb-4 text-xl font-semibold font-secondary;
  }

  .details {
    @apply mb-2 text-gray-500;
  }
}

.commands {
  @apply flex justify-center p-4 pt-0;

  button + button {
    @apply ml-4;
  }
}
</style>